"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretRightIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var CaretRightIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M9.73214286,6.875 C9.8965782,6.875 10.0388759,6.93508124 10.1590402,7.05524554 L14.4090402,11.3052455 C14.5292045,11.4254098 14.5892857,11.5677075 14.5892857,11.7321429 C14.5892857,11.8965782 14.5292045,12.0388759 14.4090402,12.1590402 L10.1590402,16.4090402 C10.0388759,16.5292045 9.8965782,16.5892857 9.73214286,16.5892857 C9.56770751,16.5892857 9.42540983,16.5292045 9.30524554,16.4090402 C9.18508124,16.2888759 9.125,16.1465782 9.125,15.9821429 L9.125,7.48214286 C9.125,7.31770751 9.18508124,7.17540983 9.30524554,7.05524554 C9.42540983,6.93508124 9.56770751,6.875 9.73214286,6.875 Z" }))); };
exports.CaretRightIcon = CaretRightIcon;
